import useTranslation from "hooks/useTranslation";
import { useSelector } from "react-redux";
import { getNotifMsg } from "utils/message";
import Alert from "../Alert";
import { FindWirelessConnection } from "assets/icons";

const mapState = ({ connectionData }) => connectionData.isReconnecting;

function ReconnectingAlert() {
  const { getAppLocale } = useTranslation(["CHAT", "COMMON"]);
  const locale = getAppLocale();

  const isReconnecting = useSelector(mapState);
  const text = getNotifMsg("RECONNECTING", locale);

  const renderIcon = <FindWirelessConnection />;

  return (
    isReconnecting && <Alert icon={renderIcon} type="connecting" text={text} />
  );
}

export default ReconnectingAlert;
